import React, { useEffect } from 'react';
import { ThemeProvider } from "@mui/material/styles";
import { Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import Home from "./Components/Home";
import theme from "./Theme";
import "./lines.scss";
import DragonMilkBackground from "./Components/NavBar/DragonMilkBackground";

gsap.registerPlugin(ScrollToPlugin);

const SECTION_OFFSET = 24;

function useSmoothScrollToSection() {
  useEffect(() => {
    const handleClick = (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const href = link.getAttribute("href");
      if (href === "#" || !href) return;
      const id = href.slice(1);
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      gsap.to(window, {
        duration: 1.2,
        ease: "power2.inOut",
        scrollTo: {
          y: target,
          offsetY: SECTION_OFFSET,
          autoKill: false,
        },
      });
    };
    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);
}

function AppContent() {
  useSmoothScrollToSection();
  return (
    <>
      <DragonMilkBackground />
      <Routes>
        <Route path="/" element={<Home />} />
    
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="cursor">
      <ThemeProvider theme={theme}>
        <LanguageProvider>
          <AppContent />
        </LanguageProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
